// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3Qied","local":"styles_local__3-OnL","remote":"styles_remote__2RUmv","wait":"styles_wait__1R09h"};